<div class="popup-header">Update Companies</div>
<br>
<div mat-dialog-content>

  <mat-chip-grid #chipGrid aria-label="Fruit selection">
    <mat-chip-row *ngFor="let fruit of emailList "  [removable]="removable"
      (removed)="remove(fruit)">
      {{fruit.name}}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip-row>
    <input placeholder="Companies" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let fruit of companies$ | async" [disabled]="fruit.active" [value]="fruit">
      {{fruit.name}}
    </mat-option>
  </mat-autocomplete>


</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
</div>